


































import { defineComponent, computed } from '@vue/composition-api';
import { useRoute } from '@/hooks/useRoute';
import { useStore } from '@/hooks/useStore';
import { getRedirectDefaultPageUrl } from '@/lib/defaultPageHelper';
import { useLogout } from '@/composables/useLogout';

export default defineComponent({
  name: 'driver-global-header',
  setup() {
    const store = useStore();
    const userState = store.state.user;
    const displayName = computed<string>(() => userState.display_name);

    const { route } = useRoute();

    const routePath = computed<string>(() => {
      return route.value.path || '';
    });
    const workStartPagePath = computed<string>(() => {
      return getRedirectDefaultPageUrl({
        useJohaisetsuOnly: userState.use_johaisetsu_only,
        useCleaningOnly: userState.use_cleaning_only,
        defaultPage: userState.default_page,
      });
    });

    const { logout } = useLogout();

    return {
      displayName,
      routePath,
      workStartPagePath,
      logout,
    };
  },
});
